import { render, staticRenderFns } from "./PrinterLimits.vue?vue&type=template&id=49817ba0&"
import script from "./PrinterLimits.vue?vue&type=script&lang=ts&"
export * from "./PrinterLimits.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports